import {
    Container,
    Grid,
    Paper,
    Theme,
    Typography,
} from "@mui/material";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CircuitBests } from "./CircuitBests";
import CircuitServiceInstance from "../../services/CircuitService";
import OntimeBreadcrumb from "../common/OntimeBreadcrumb";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
        },
        container: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
        },
        appBarSpacer: theme.mixins.toolbar,
        fixedHeight: {
            height: 1024,
        },
    }));

function CircuitCarsHallOfFamePage() {
    const { circuitId } = useParams();
    const [circuitName, setCircuitName] = useState<string>('');
    const classes = useStyles();
    const { t } = useTranslation("common");
    const fixedHeightPaper = clsx(classes.fixedHeight);

    useEffect(() => {
        if (!circuitId) return;
        const source = axios.CancelToken.source();
        CircuitServiceInstance.getCircuit(circuitId, source.token).then((circuit) => {
            setCircuitName(circuit.name);
        }).catch((error) => {
            if (!axios.isCancel(error)) {
                console.error('Failed to fetch circuit:', error);
            }
        });
        return () => { source.cancel(); };
    }, [circuitId]);

    const breadcrumbMap: Record<string, string> = {
        [t('mainList.circuits')]: '/circuits',
        [circuitName]: `/circuits/${circuitId}`,
    };

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <OntimeBreadcrumb nameMap={breadcrumbMap} current={t("circuit.carsHallOfFame")} />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h4">{t("circuit.carsHallOfFame")}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper className={fixedHeightPaper}>
                            <Typography variant="h6" component="div">
                                {t("circuit.bestTimes")}
                            </Typography>
                            {circuitId && <CircuitBests circuitId={circuitId} eventType={"2"} />}
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </main>
    );
}

export default CircuitCarsHallOfFamePage;
